export const isProd = () => {
  if (window) {
    return window.location.href.indexOf('.narvar.com') > -1;
  }
  return false;
};

export const isQA = () => {
  if (window) {
    return window.location.href.indexOf('.narvar.qa') > -1;
  }
  return false;
};
